import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from "./pages/home/home.component";
import {AccessDeniedComponent} from "./pages/access-denied/access-denied.component";

const routes: Routes = [
  {path: "", component: HomeComponent},
  {path: "access-denied", component: AccessDeniedComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

